import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {POLL_OPTION, TENANT_SELECTABLE_POLL_OPTION} from "../../../../tenant/Config/ApiUrl";

const state = {
    called: false,
    pollOption:{},
    selectable: [],
}

const actions = {
    getPollOptionDetails({commit, state}, pollOptionId){
        commit('SET_CALLED', true)
        axiosGet(`${POLL_OPTION}/${pollOptionId}`).then(({ data }) =>{
            commit('POLL_OPTION_DETAILS_DATA', data)
        }).finally(()=> commit('SET_LOADER', false))
    },
    getSelectablePollOptions({commit, state}) {
        commit('SET_CALLED', true);
        axiosGet(`${TENANT_SELECTABLE_POLL_OPTION}`).then(({data}) => {
            commit('SKILL_POLL_OPTION_LIST', data)
        });
    },
}

const mutations = {
    POLL_OPTION_DETAILS_DATA(state, data){
        state.pollOption = data;
    },
    SKILL_POLL_OPTION_LIST(state, data) {
        state.selectable = data;
    },
    SET_CALLED(state, data) {
        state.called = data;
    }
}

export default {
    state,
    actions,
    mutations
}
